import { render, staticRenderFns } from "./SystemCardTemplate.vue?vue&type=template&id=384e50cc&scoped=true"
import script from "./SystemCardTemplate.vue?vue&type=script&lang=js"
export * from "./SystemCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./SystemCardTemplate.vue?vue&type=style&index=0&id=384e50cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e50cc",
  null
  
)

export default component.exports